module.exports = __webpack_public_path__ + "static/media/settings.5c4e6c02.svg";